<template>
    <textarea v-if="this.FactType == 'textarea'" :id="id" ref='input' class="form-control input-container"  :style="this.style" :class='{"invalid": this.invalid, "success": this.success}' :placeholder="this.place" :autocomplete="this.autocomplete" :disabled='this.disabled' v-on:blur="this.blur" v-model="this.value" v-on:input="this.setValue"></textarea>
    <div class='wid position-relative d-flex flex-row align-items-center justify-content-start' v-else>
        <input :id="id" :type='this.FactType' ref='input' 
        :style="this.style" 
        :autocomplete="this.autocomplete" 
        :placeholder="this.place" 
        :class='{"invalid": this.invalid, "success": this.success}' 
        class="form-control input-container" 
        :disabled='this.disabled' 
        :maxlength="this.maxlength" 
        v-model="this.value" 
        v-on:blur="this.blur" 
        v-on:input="this.setValue"
        v-on:keyup.enter="this.onEnter">
        <div v-if="this.origType == 'password'"
            class="eye-wrap"
            :class="{'not_single': this.invalid || this.success, 'single': !this.invalid && !this.success}"
            role="button"
            tabindex="0"
            :aria-label="this.FactType == 'password' ? $t('views.Login.48') : $t('views.Login.49')"
            v-on:click="this.passWisibility"
            v-on:keydown.enter.prevent="this.passWisibility"
            v-on:keydown.space.prevent="this.passWisibility">
            <i class="item-i" :class="{'eye-off': this.FactType == 'password', 'eye': this.FactType != 'password'}"></i>
        </div>
        <div v-if='this.invalidHint && this.invalid' :id="this.id + '_warning'" role="alert" class="invalid-tooltip">
            {{this.invalidHint}}
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            value: this.dataValue ? this.dataValue : '',
            place: this.placeholder ? this.placeholder : '',
            sizeW: this.$store.state.resize.w,
            FactType: this.type, 
            origType: this.type
        }
    },
    props: {
        id: [String, Boolean],
        type: [String],
        dataValue: [String, Boolean, Number], 
        disabled: [String, Boolean],
        autofocus: [Boolean],
        regCheck: [Object, Boolean],
        invalid: [Boolean, String],
        success: [Boolean], 
        invalidHint: [String, Boolean],
        placeholder: [String, Boolean], 
        style: [Boolean, String],
        autocomplete: {
            type: [String, Boolean],
            default: false,
        },
        maxlength: {
            type: [Number, String],
            default: null,
        },
    },
    mounted() {
        if (this.autofocus) {
            this.$nextTick(() => this.focusInput())
        }
    },
    methods: {
        setValue() {
            if (this.regCheck) {
                let pre_value = this.regCheck.f(this.value);
                if (pre_value === false) {
                    return;
                }
                this.value = this.regCheck.f(this.value);
            }
            this.$emit('updateParentState', {
                id: this.id,
                value: this.value
            })
        },
        blur() {
            this.$emit('blurInput', {
                id: this.id,
                value: this.value
            })
        },
        onEnter() {
            this.$emit('onEnter');
        },
        focusInput() {
            this.$refs.input.focus();
        },
        passWisibility() {
            if (this.FactType == 'password') {
                this.FactType = 'text'
            } else {
                this.FactType = 'password'
            }
        }
    },
    watch: {
        dataValue(newV, oldV) {
            // if (newV != oldV) {
                // console.log(newV, oldV)
                this.value = newV ? newV : '';
            // }
        }
    }

}
</script>

<style lang="scss" scoped>
// Auth redesign — поле ввода по макету Claude Design (см. docs/auth-redesign-plan.md).
// Токены из includes/_auth-tokens.scss. Scoped → [data-v] перебивает Bootstrap .form-control.
.input-container {
    width: 100%;
    height: 50px;
    padding: 0 16px;
    font-family: "HelveticaNeue roman", "Roboto", sans-serif;
    font-size: 15px;
    color: var(--ink);
    background: var(--field);
    border: 1.5px solid var(--line-strong);
    border-radius: var(--radius-field);
    outline: none;
    box-shadow: none;
    transition: border-color .16s ease, box-shadow .16s ease, background .16s ease;
}
textarea.input-container {
    height: auto;
    min-height: 92px;
    padding: 12px 16px;
    line-height: 1.5;
}
.input-container::placeholder {
    color: var(--ink-faint);
}
.input-container:hover {
    border-color: #bcc0cc;
}
.input-container:focus {
    border-color: var(--accent);
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--accent) 16%, transparent);
}
.input-container:disabled {
    background: #f7f7f9;
    color: var(--ink-faint);
    cursor: not-allowed;
}

// валидные/невалидные состояния — border-only, как в макете (без Bootstrap bg-иконок)
.invalid {
    border-color: var(--danger);
}
.invalid:focus {
    border-color: var(--danger);
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--danger) 14%, transparent);
}
.success {
    border-color: var(--ok);
}
.success:focus {
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--ok) 16%, transparent);
}

// поле с «глазом» — место под кнопку справа
.wid:has(.eye-wrap) .input-container { padding-right: 48px; }

.eye-wrap {
    position: absolute;
    right: 7px;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border-radius: 8px;
    cursor: pointer;
    transition: background .15s ease;
    &:hover { background: #f1f2f5; }
    .item-i {
        width: 20px; height: 20px;
        min-width: 20px; min-height: 20px;
        background-size: contain;
    }
}

// .wid — это d-flex flex-row, поэтому tooltip переносим на новую строку (вниз), не вправо (#8)
.invalid-tooltip {
    display: block;
    position: static;
    flex: 0 0 100%;
    width: 100%;
    margin-top: 9px;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 12.5px;
    line-height: 1.4;
    color: var(--danger);
}
.wid {
    width: 100%;
    position: relative;
    flex-wrap: wrap;
}
</style>